module.exports = __webpack_public_path__ + "img/close.ceab71d5.png";